import { render, staticRenderFns } from "./ArtigosPerigososPopover.vue?vue&type=template&id=22777c0c"
import script from "./ArtigosPerigososPopover.vue?vue&type=script&lang=js"
export * from "./ArtigosPerigososPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports